import flowStore from 'src/stores/flowStore';
import RedirectView from './view';

const REDIRECT_DELAY = 1000;

const redirect = (url) => {
  window.location = url;
};

export default class RedirectController {
  constructor() {
    this.view = new RedirectView();
  }

  onStateChange() {
    const activeNode = flowStore.getActiveNode();
    this.view.render(activeNode.getOptions());
    setTimeout(() => redirect(activeNode.getURL()), REDIRECT_DELAY);
  }
}
